/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
function l(l,e){return!!(l.layer&&"globalIdField"in l.layer&&l.layer.globalIdField&&e.fromNetworkElement)&&l.attributes[l.layer.globalIdField]===e.fromNetworkElement.globalId}export{l as isFromElement};
